(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-two-column-slider"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    document.querySelector('.js-toggle-slider').addEventListener('click', (e) => {
      const targetType =
        typeof e.detail == 'string'
          ? e.detail
          : e.target.getAttribute('data-target-type') ||
            e.target.closest('[data-target-type]').getAttribute('data-target-type')

      document.querySelectorAll('[data-slider-type]').forEach((slider) => {
        const sliderTarget = slider.getAttribute('data-slider-type')
        if (sliderTarget === targetType) {
          slider.classList.add('slider-shown')
          document.querySelector(`[data-target-type="${sliderTarget}"]`).classList.add('is-active')
        } else {
          slider.classList.remove('slider-shown')
          document.querySelector(`[data-target-type="${sliderTarget}"]`).classList.remove('is-active')
        }
      })
    })

    document.addEventListener('DOMContentLoaded', () => {
      const ctas = document.querySelectorAll('[data-target-type]')
      const index = Array.from(ctas).findIndex((cta) => cta.classList.contains('is-active'))

      if (index < 0) {
        ctas[0].dispatchEvent(
          new CustomEvent('click', { bubbles: true, detail: { type: ctas[0].getAttribute('data-target-type') } })
        )
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-nosto-recommendation"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.js-read-more').forEach(readTrigger => {
      readTrigger.addEventListener('click', e => {
        if (readTrigger.previousElementSibling?.classList.contains('expanded')) {
          readTrigger.classList.remove('expanded')
          readTrigger.previousElementSibling.classList.remove('expanded')
        } else {
          readTrigger.classList.add('expanded')
          readTrigger.previousElementSibling?.classList.add('expanded')
        }
      })
    })
  
  } catch(e) { console.error(e); }
})();
})();
